import React from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  SwipeableDrawer,
  Typography,
  Checkbox,
  FormControlLabel,
  useMediaQuery,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { getLabelStatusCadeiaDeCustodia } from 'helpers/labels'
import SendIcon from '@material-ui/icons/Send'
import DoneOutlineIcon from '@material-ui/icons/DoneOutline'
import NotInterestedIcon from '@material-ui/icons/NotInterested'
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn'
import NextWeekIcon from '@material-ui/icons/NextWeek'
import ArchiveIcon from '@material-ui/icons/Archive'
import UnarchiveIcon from '@material-ui/icons/Unarchive'
import CloseIcon from '@material-ui/icons/Close'
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import CallMadeIcon from '@material-ui/icons/CallMade'
import FlagIcon from '@material-ui/icons/Flag'
import WhatshotIcon from '@material-ui/icons/Whatshot';
import CallReceivedIcon from '@material-ui/icons/CallReceived'
import HowToRegIcon from '@material-ui/icons/HowToReg'
import { AddBox } from '@material-ui/icons'

import { CustomButton, ObjetoAvatar } from 'components'
import { FormRetornarVestigio } from 'components/FormRetornarVestigio'
import { FormGuardarVestigio } from 'components/FormGuardarVestigio'
import { FormEncaminhamentoVestigio } from 'components/FormEncaminhamentoVestigio'
import { FormPassagemCustodia } from 'components/FormPassagemCustodia'
import { FormSolicitacaoVestigio } from 'components/FormSolicitacaoVestigio'
import { FormConsumirVestigio } from 'components/FormConsumirVestigio'
import { FormEncaminhamentoComConfirmacao } from 'components/FormEncaminharComConfirmacao'
import { FormAlterarSituacaoVestigio } from 'components/FormAlterarSituacaoVestigio'
import { ConfirmarIdentidade } from 'components/ConfirmarIdentidade'
import { PainelAcoesCesta } from './components/PainelAcoesCesta'
import { FormDescartarVestigio } from 'components/FormDescartarVestigio'
import { ModalConfirmacao } from 'components/ModalConfirmacao'
import constants from 'utils/constants'
import Cesta from './basket.svg'

import { useStyles } from './OperacaoVestigioLote.styles'
import { useOperacaoVestigioLote } from './hooks/useOperacaoVestigioLote'

export const OperacaoVestigioLote = (props) => {
  const { setOpenMenuOperacao } = props
  const classes = useStyles()
  const theme = useTheme()
  const isXs = useMediaQuery(theme.breakpoints.down('xs'))
  const isSm = useMediaQuery(theme.breakpoints.down('sm'))
  const isMd = useMediaQuery(theme.breakpoints.down('md'))

  const {
    form,
    setForm,
    operacao,
    openForm,
    setOpenForm,
    processandoOperacao,
    formError,
    manterVestigioNaCesta,
    setManterVestigioNaCesta,
    abrirConfirmarIdentidade,
    setAbrirConfirmarIdentidade,
    abrirAviso,
    setAbrirAviso,
    aceito,
    autenticado,
    cancelado,
    vestigiosComCadeiaCustodia,
    processandoVestigiosComCadeiaCustodia,
    setVestigiosSelecionados,
    currentUser,
    verificarPermissao,
    confirmarOperacao,
    verificarTodosEntregues,
    verificarTodosComUsuario,
    verificarUsuarioPertenceSetorAtualVestigio,
    verificarUsuarioPertenceSetorDestinoVestigio,
    verificarTodosGuardadosNoSetorDeUsuario,
    verificarTodosGuardadosNoMesmoSetor,
    verificarUsuarioDestinoPassagemCustodia,
    verificarTodosEmPassagemCustodia,
    changeForm,
    handleClickAcao,
    custodiaAtual,
    handleCancelarOperacao,
    handleClickVestigio,
    removerVestigio,
  } = useOperacaoVestigioLote(setOpenMenuOperacao)

  const acoes = [
    {
      tituloSecao: "No setor",
      acoes: [
        {
          nome: 'Guardar',
          Icon: ArchiveIcon,
          onClick: () => handleClickAcao('GUARDAR'),
          disabled: !verificarTodosComUsuario(),
          helpText: 'Todos os vestígios devem estar sob sua custódia para habilitar esta ação.',
        },
        {
          nome: 'Retirar',
          Icon: UnarchiveIcon,
          onClick: () => handleClickAcao('RETIRAR'),
          disabled: !verificarTodosGuardadosNoSetorDeUsuario(),
          helpText: 'Todos os vestígios devem estar guardados num setor de que você faça parte para habilitar esta ação.',
        },
        {
          nome: 'Consumir',
          Icon: WhatshotIcon,
          onClick: () => handleClickAcao('CONSUMIR'),
          disabled: !verificarTodosComUsuario(),
          helpText: 'Todos os vestígios devem estar sob sua custódia para habilitar esta ação.',
        },
        {
          tipo: 'split',
          acoes: [
            {
              nome: 'Passar custódia',
              Icon: NextWeekIcon,
              onClick: () => handleClickAcao('PASSAR_CUSTODIA'),
              disabled: !verificarTodosComUsuario() || !verificarPermissao([constants.PERMISSOES.SOLICITAR_PASSAGEM_CUSTODIA]),
              helpText: 'Todos os vestígios devem estar sob sua custódia para habilitar esta ação.',
            },
            {
              nome: 'Aceitar passagem',
              Icon: DoneOutlineIcon,
              onClick: () => handleClickAcao('ACEITAR_PASSAGEM_CUSTODIA'),
              disabled: !verificarTodosEmPassagemCustodia() || !verificarUsuarioDestinoPassagemCustodia(),
              helpText: 'Todos os vestígios devem estar com passagem de custódia em aberto para um de seus setores para habilitar esta ação.',
            },
            {
              nome: 'Negar passagem',
              Icon: NotInterestedIcon,
              onClick: () => handleClickAcao('NEGAR_PASSAGEM_CUSTODIA'),
              disabled: !verificarTodosEmPassagemCustodia() || !verificarUsuarioDestinoPassagemCustodia(),
              helpText: 'Todos os vestígios devem estar com passagem de custódia em aberto para um de seus setores para habilitar esta ação.',
            },
            {
              nome: 'Com confirmação',
              Icon: HowToRegIcon,
              onClick: () => handleClickAcao('ENCAMINHAR_COM_CONFIRMACAO'),
              disabled: !verificarTodosComUsuario(),
              helpText: 'Todos os vestígios devem estar sob sua custódia para habilitar esta ação.',
            }
          ],
        },
        {
          nome: 'Criar novo lote',
          Icon: AddBox,
          onClick: () => handleClickAcao('CRIAR_NOVO_LOTE'),
          disabled: false,
          helpText: null,
        },
      ], 
    },
    {
      tituloSecao: "Entre setores",
      acoes: [
        {
          nome: 'Solicitar',
          Icon: CallReceivedIcon,
          onClick: () => handleClickAcao('SOLICITAR'),
          disabled: !verificarTodosGuardadosNoMesmoSetor(),
          helpText: 'Todos os vestígios devem estar guardados no mesmo setor para habilitar esta ação.',
        },
        {
          tipo: 'split',
          acoes: [
            {
              nome: 'Encaminhar',
              Icon: SendIcon,
              onClick: () => handleClickAcao('ENCAMINHAR'),
              disabled: !verificarTodosComUsuario() || !verificarPermissao([constants.PERMISSOES.ENCAMINHAR_VESTIGIO]),
              helpText: 'Todos os vestígios devem estar sob sua custódia para habilitar esta ação.',
            },
            {
              nome: 'Aceitar encaminhamento',
              Icon: DoneOutlineIcon,
              onClick: () => handleClickAcao('ACEITAR_ENCAMINHAMENTO'),
              disabled: !verificarUsuarioPertenceSetorDestinoVestigio(),
              helpText: 'Você deve estar no setor destino de todos os vestígios e todos precisam estar com encaminhamento em aberto para habilitar esta ação.',
            },
            {
              nome: 'Negar encaminhamento',
              Icon: NotInterestedIcon,
              onClick: () => handleClickAcao('NEGAR_ENCAMINHAMENTO'),
              disabled: !verificarUsuarioPertenceSetorDestinoVestigio(),
              helpText: 'Você deve estar no setor destino de todos os vestígios e todos precisam estar com encaminhamento em aberto para habilitar esta ação.',
            },
            {
              nome: 'Com confirmação',
              Icon: HowToRegIcon,
              onClick: () => handleClickAcao('ENCAMINHAR_COM_CONFIRMACAO'),
              disabled: !verificarTodosComUsuario(),
              helpText: 'Todos os vestígios devem estar sob sua custódia para habilitar esta ação.',
            },
          ],
        },
      ],
    },
    {
      tituloSecao: 'Ações Externas',
      acoes: [
        { 
          tipo: 'split',
          acoes: [
            {
              nome: 'Entregar',
              Icon: CallMadeIcon,
              onClick: () => handleClickAcao('ENTREGAR'),
              disabled: !verificarTodosComUsuario(),
              helpText: 'Todos os vestígios devem estar sob sua custódia para habilitar esta ação.',
            },
            {
              nome: 'Com confirmação',
              Icon: CallMadeIcon,
              onClick: () => handleClickAcao('ENTREGAR_COM_CONFIRMACAO'),
              disabled: !verificarTodosComUsuario(),
              helpText: 'Todos os vestígios devem estar sob sua custódia para habilitar esta ação.',
            },
          ],
        },
        {
          nome: 'Retornar',
          Icon: KeyboardReturnIcon,
          onClick: () => handleClickAcao('RETORNAR'),
          disabled: !verificarTodosEntregues() || !verificarPermissao([constants.PERMISSOES.RETORNAR_VESTIGIO]),
          helpText: 'Todos os vestígios devem estar entregues para habilitar esta ação.',
        },
        {
          nome: 'Alterar situação',
          Icon: FlagIcon,
          onClick: () => handleClickAcao('ALTERAR_SITUACAO'),
          disabled: !verificarTodosGuardadosNoSetorDeUsuario(),
          helpText: 'Todos os vestígios devem estar guardados no mesmo setor para habilitar esta ação.',
          hidden: !currentUser.setores.some((s) => s.id === 184),
        },
        {
          nome: 'Descartar',
          Icon: DeleteForeverIcon,
          onClick: () => handleClickAcao('DESCARTAR'),
          disabled: !verificarTodosComUsuario(),
          helpText: 'Todos os vestígios devem estar sob sua custódia para habilitar esta ação.',
        },
      ],
    },
  ]


  return (
    <>
      <div style={{ width: isXs ? '100vw' : isSm ? '80vw' : isMd ? '40vw' : '30vw', maxWidth: '100%' }} className={classes.divOperacaoLote}>
          <div className={classes.titulo}>
            <img src={Cesta} width={27} alt="Cesta" className={classes.tituloIcone} />
            <Typography className={classes.tituloCesta}>Cesta de vestígios</Typography>
          </div>
          <Divider />
          {!!vestigiosComCadeiaCustodia?.length && (
          <Grid container spacing={2} className={classes.menuAcoes}>
            <PainelAcoesCesta acoes={acoes} />
          </Grid>)}
          {!!vestigiosComCadeiaCustodia?.length && (
          <Grid container className={classes.menuAcoes}>
            <Grid item xs={12} className={classes.gridTituloAcoes}>
              <Typography className={classes.tituloAcoes}> Vestígios selecionados ({vestigiosComCadeiaCustodia.length})</Typography>
            </Grid>
            <Grid container item xs={12} justifyContent="space-between" style={{ padding: '0 16px 8px 16px', flexBasis: 'auto' }}>
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={manterVestigioNaCesta}
                      onChange={(e) => setManterVestigioNaCesta(e.target.checked)}
                      name="manterVestigios"
                      color="primary"
                    />
                  }
                  label="Manter na cesta"
                />
              </Grid>
              <Grid item>
                <CustomButton
                  variant="text"
                  colorType="primary"
                  startIcon={<DeleteSweepIcon />}
                  onClick={() => setVestigiosSelecionados([])}
                >
                  Limpar Cesta
                </CustomButton>
              </Grid>
            </Grid>
          </Grid>)}
          <Grid container className={classes.containerCestinha}>
            {processandoVestigiosComCadeiaCustodia ? (
              <div className={classes.carregando}>
                <CircularProgress disableShrink />
              </div>
            ) : (
              vestigiosComCadeiaCustodia.map((v) => (
                <Grid item xs={12} key={v.id}>
                  <Card className={classes.itemCestinha}>
                    <div className={classes.tituloItemCestinha} onClick={() => handleClickVestigio(v.id)}>
                      <ObjetoAvatar tipo="VESTIGIO" />
                      <Typography>
                        <b title="Clique para acessar as informações do vestígio">{v.identificador}</b>
                      </Typography>
                    </div>
                    <div className={classes.divConteudoItemCestinha}>
                      <div className={classes.informacoesItemCestinha}>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography>
                              <b>Lacre:</b> {v.lacre}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography>
                              <b>Lote:</b> {v.lote ? v.lote.numero : '-'}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography>
                              <b>Status:</b> {getLabelStatusCadeiaDeCustodia(v.statusCadeiaCustodia)}
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography>
                              <b>Custódia atual:</b> {custodiaAtual(v)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.divExcluirItem}>
                        <IconButton onClick={() => removerVestigio(v.id)} title="Retirar vestígio da cesta">
                          <CloseIcon />
                        </IconButton>
                      </div>
                    </div>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
          {!vestigiosComCadeiaCustodia?.length && (
            <Grid item xs={12} style={{ display: 'grid', placeContent: 'center', textAlign: 'center', gap: '16px'}}>
              <img alt="Carrinho vazio" src="/images/undraw_empty-cart_574u.svg" style={{ maxWidth: '300px', width: '90%', placeSelf: 'center' }} />
              <Typography>Nenhum vestígio na cesta</Typography>
            </Grid>
          )}
        <SwipeableDrawer anchor={'right'} open={openForm} onClose={() => setOpenForm(false)}>
          <div style={{ width: isXs ? '100vw' : isSm ? '80vw' : isMd ? '40vw' : '30vw', maxWidth: '100%' }} className={classes.divOperacaoLote}>
            <div style={{ flexGrow: 1}}>
              {operacao === 'RETORNAR' && <FormRetornarVestigio form={form} setForm={setForm} handleChange={changeForm} multiple={vestigiosComCadeiaCustodia?.length > 1} />}
              {operacao === 'GUARDAR' && <FormGuardarVestigio form={form} setForm={setForm} handleChange={changeForm} multiple={vestigiosComCadeiaCustodia?.length > 1} />}
              {(operacao === 'RETIRAR' || operacao === 'ACEITAR_ENCAMINHAMENTO' || operacao === 'ACEITAR_PASSAGEM_CUSTODIA') && (
                <div style={{ padding: '25px', alignContent: 'center', textAlign: 'center' }}>
                  <Typography variant="h5">Os vestígios selecionados ficarão sob sua responsabilidade.</Typography>
                </div>
              )}
              {operacao === 'ENCAMINHAR' && <FormEncaminhamentoVestigio form={form} handleChange={changeForm} multiple={vestigiosComCadeiaCustodia?.length > 1} />}
              {(operacao === 'NEGAR_ENCAMINHAMENTO' || operacao === 'NEGAR_PASSAGEM_CUSTODIA') && (
                <div style={{ padding: '25px', alignContent: 'center', textAlign: 'center' }}>
                  <Typography variant="h5">Tem certeza que deseja negar o encaminhamento do vestígio?</Typography>
                </div>
              )}
              {operacao === 'PASSAR_CUSTODIA' && <FormPassagemCustodia form={form} vestigios={vestigiosComCadeiaCustodia} handleChange={changeForm} multiple={vestigiosComCadeiaCustodia?.length > 1} />}
              {operacao === 'CONSUMIR' && <FormConsumirVestigio form={form} handleChange={changeForm} multiple={vestigiosComCadeiaCustodia?.length > 1} />}
              {operacao === 'SOLICITAR' && <FormSolicitacaoVestigio form={form} handleChange={changeForm} user={currentUser} multiple={vestigiosComCadeiaCustodia?.length > 1} setor={vestigiosComCadeiaCustodia[0]?.setAtual} />}
              {operacao === 'ALTERAR_SITUACAO' && <FormAlterarSituacaoVestigio form={form} handleChange={changeForm} />}
              {operacao === 'DESCARTAR' && <FormDescartarVestigio form={form} handleChange={changeForm} user={currentUser} multiple={vestigiosComCadeiaCustodia?.length > 1} setor={vestigiosComCadeiaCustodia[0]?.setAtual} />}
              {(operacao === 'ENTREGAR_COM_CONFIRMACAO' || operacao === 'ENTREGAR') && <FormEncaminhamentoComConfirmacao operacao={operacao} form={form} handleChange={changeForm} multiple={vestigiosComCadeiaCustodia?.length > 1} />}
              {operacao === 'CRIAR_NOVO_LOTE' && (
                <div style={{ padding: '25px', alignContent: 'center', textAlign: 'center' }}>
                  <Typography variant="h5">Os vestígios selecionados serão inseridos no novo lote. Deseja confirmar a criação do novo lote?</Typography>
                </div>
              )}
              {operacao === 'ENCAMINHAR_COM_CONFIRMACAO' && <FormEncaminhamentoComConfirmacao operacao={operacao} form={form} handleChange={changeForm} multiple={vestigiosComCadeiaCustodia?.length > 1} />}
            </div>

            <div className={classes.divBotoes}>
              <CustomButton variant="outlined" colorType="primary" onClick={handleCancelarOperacao}>
                Cancelar
              </CustomButton>
              <CustomButton
                disabled={formError}
                isLoading={processandoOperacao}
                variant="contained"
                colorType="primary"
                onClick={confirmarOperacao}
              >
                Confirmar
              </CustomButton>
            </div>
          </div>
        </SwipeableDrawer>
        {abrirConfirmarIdentidade && form.usuarioDestino?.cpf && (
          <ConfirmarIdentidade
            aberto={abrirConfirmarIdentidade}
            setAberto={setAbrirConfirmarIdentidade}
            callback={() => {
              autenticado.current = true
            }}
            failback={() => {
              cancelado.current = true
            }}
            titulo={`Aceitar Vestígio - ${form.usuarioDestino?.nome.split(' ')[0] || ''}`}
            CPFparaValidacao={form.usuarioDestino?.cpf}
          />
        )}
        {abrirAviso && (
        <ModalConfirmacao
          aberto={abrirAviso}
          onClose={() => {
            cancelado.current = true
            setAbrirAviso(false)
          }}
          onConfirm={() => {
            aceito.current = true
            setAbrirAviso(false)}
          }
          titulo={`Você tem certeza de que deseja descartar ${vestigiosComCadeiaCustodia?.length > 1 ? 'esses vestígios' : 'esse vestígio'}?`}
          confirmarLabel="Confirmar Descarte"
          cancelarLabel="Cancelar"
          confirmarColor="secondary"
          maxWidth="sm"
          >
			  	<Typography variant="body1">
			  		Esta ação é irreversível e alterará permanentemente o status {vestigiosComCadeiaCustodia?.length > 1 ? 'dos vestígios' : 'do vestígio'} para descartado.
			  	</Typography>
			  </ModalConfirmacao>
        )}
      </div>
    </>
  )
}

OperacaoVestigioLote.propTypes = {
  setOpenMenuOperacao: PropTypes.func.isRequired,
}
